import _toConsumableArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import './sash.css';
import { dispose, Disposable, DisposableStore } from '../../../common/lifecycle.js';
import { isMacintosh } from '../../../common/platform.js';
import * as types from '../../../common/types.js';
import { EventType, Gesture } from '../../touch.js';
import { StandardMouseEvent } from '../../mouseEvent.js';
import { Emitter } from '../../../common/event.js';
import { getElementsByTagName, EventHelper, createStyleSheet, addDisposableListener, append, $, addClass, removeClass, toggleClass } from '../../dom.js';
import { domEvent } from '../../event.js';
var DEBUG = false;
var globalSize = 4;
var onDidChangeGlobalSize = new Emitter();
export var Sash = /*#__PURE__*/function (_Disposable) {
  _inherits(Sash, _Disposable);

  var _super = _createSuper(Sash);

  function Sash(container, layoutProvider, options) {
    var _this;

    _classCallCheck(this, Sash);

    _this = _super.call(this);
    _this._state = 3
    /* Enabled */
    ;
    _this._onDidEnablementChange = _this._register(new Emitter());
    _this.onDidEnablementChange = _this._onDidEnablementChange.event;
    _this._onDidStart = _this._register(new Emitter());
    _this.onDidStart = _this._onDidStart.event;
    _this._onDidChange = _this._register(new Emitter());
    _this.onDidChange = _this._onDidChange.event;
    _this._onDidReset = _this._register(new Emitter());
    _this.onDidReset = _this._onDidReset.event;
    _this._onDidEnd = _this._register(new Emitter());
    _this.onDidEnd = _this._onDidEnd.event;
    _this.linkedSash = undefined;
    _this.orthogonalStartSashDisposables = _this._register(new DisposableStore());
    _this.orthogonalEndSashDisposables = _this._register(new DisposableStore());
    _this.el = append(container, $('.monaco-sash'));

    if (isMacintosh) {
      addClass(_this.el, 'mac');
    }

    _this._register(domEvent(_this.el, 'mousedown')(_this.onMouseDown, _assertThisInitialized(_this)));

    _this._register(domEvent(_this.el, 'dblclick')(_this.onMouseDoubleClick, _assertThisInitialized(_this)));

    _this._register(Gesture.addTarget(_this.el));

    _this._register(domEvent(_this.el, EventType.Start)(_this.onTouchStart, _assertThisInitialized(_this)));

    if (typeof options.size === 'number') {
      _this.size = options.size;

      if (options.orientation === 0
      /* VERTICAL */
      ) {
        _this.el.style.width = "".concat(_this.size, "px");
      } else {
        _this.el.style.height = "".concat(_this.size, "px");
      }
    } else {
      _this.size = globalSize;

      _this._register(onDidChangeGlobalSize.event(function (size) {
        _this.size = size;

        _this.layout();
      }));
    }

    _this.hidden = false;
    _this.layoutProvider = layoutProvider;
    _this.orthogonalStartSash = options.orthogonalStartSash;
    _this.orthogonalEndSash = options.orthogonalEndSash;
    _this.orientation = options.orientation || 0
    /* VERTICAL */
    ;

    if (_this.orientation === 1
    /* HORIZONTAL */
    ) {
      addClass(_this.el, 'horizontal');
      removeClass(_this.el, 'vertical');
    } else {
      removeClass(_this.el, 'horizontal');
      addClass(_this.el, 'vertical');
    }

    toggleClass(_this.el, 'debug', DEBUG);

    _this.layout();

    return _this;
  }

  _createClass(Sash, [{
    key: "state",
    get: function get() {
      return this._state;
    },
    set: function set(state) {
      if (this._state === state) {
        return;
      }

      toggleClass(this.el, 'disabled', state === 0
      /* Disabled */
      );
      toggleClass(this.el, 'minimum', state === 1
      /* Minimum */
      );
      toggleClass(this.el, 'maximum', state === 2
      /* Maximum */
      );
      this._state = state;

      this._onDidEnablementChange.fire(state);
    }
  }, {
    key: "orthogonalStartSash",
    get: function get() {
      return this._orthogonalStartSash;
    },
    set: function set(sash) {
      this.orthogonalStartSashDisposables.clear();

      if (sash) {
        this.orthogonalStartSashDisposables.add(sash.onDidEnablementChange(this.onOrthogonalStartSashEnablementChange, this));
        this.onOrthogonalStartSashEnablementChange(sash.state);
      } else {
        this.onOrthogonalStartSashEnablementChange(0
        /* Disabled */
        );
      }

      this._orthogonalStartSash = sash;
    }
  }, {
    key: "orthogonalEndSash",
    get: function get() {
      return this._orthogonalEndSash;
    },
    set: function set(sash) {
      this.orthogonalEndSashDisposables.clear();

      if (sash) {
        this.orthogonalEndSashDisposables.add(sash.onDidEnablementChange(this.onOrthogonalEndSashEnablementChange, this));
        this.onOrthogonalEndSashEnablementChange(sash.state);
      } else {
        this.onOrthogonalEndSashEnablementChange(0
        /* Disabled */
        );
      }

      this._orthogonalEndSash = sash;
    }
  }, {
    key: "onMouseDown",
    value: function onMouseDown(e) {
      var _this2 = this;

      EventHelper.stop(e, false);
      var isMultisashResize = false;

      if (!e.__orthogonalSashEvent) {
        var orthogonalSash = this.getOrthogonalSash(e);

        if (orthogonalSash) {
          isMultisashResize = true;
          e.__orthogonalSashEvent = true;
          orthogonalSash.onMouseDown(e);
        }
      }

      if (this.linkedSash && !e.__linkedSashEvent) {
        e.__linkedSashEvent = true;
        this.linkedSash.onMouseDown(e);
      }

      if (!this.state) {
        return;
      } // Select both iframes and webviews; internally Electron nests an iframe
      // in its <webview> component, but this isn't queryable.


      var iframes = [].concat(_toConsumableArray(getElementsByTagName('iframe')), _toConsumableArray(getElementsByTagName('webview')));

      var _iterator = _createForOfIteratorHelper(iframes),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var iframe = _step.value;
          iframe.style.pointerEvents = 'none'; // disable mouse events on iframes as long as we drag the sash
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var mouseDownEvent = new StandardMouseEvent(e);
      var startX = mouseDownEvent.posx;
      var startY = mouseDownEvent.posy;
      var altKey = mouseDownEvent.altKey;
      var startEvent = {
        startX: startX,
        currentX: startX,
        startY: startY,
        currentY: startY,
        altKey: altKey
      };
      addClass(this.el, 'active');

      this._onDidStart.fire(startEvent); // fix https://github.com/Microsoft/vscode/issues/21675


      var style = createStyleSheet(this.el);

      var updateStyle = function updateStyle() {
        var cursor = '';

        if (isMultisashResize) {
          cursor = 'all-scroll';
        } else if (_this2.orientation === 1
        /* HORIZONTAL */
        ) {
          if (_this2.state === 1
          /* Minimum */
          ) {
            cursor = 's-resize';
          } else if (_this2.state === 2
          /* Maximum */
          ) {
            cursor = 'n-resize';
          } else {
            cursor = isMacintosh ? 'row-resize' : 'ns-resize';
          }
        } else {
          if (_this2.state === 1
          /* Minimum */
          ) {
            cursor = 'e-resize';
          } else if (_this2.state === 2
          /* Maximum */
          ) {
            cursor = 'w-resize';
          } else {
            cursor = isMacintosh ? 'col-resize' : 'ew-resize';
          }
        }

        style.innerHTML = "* { cursor: ".concat(cursor, " !important; }");
      };

      var disposables = new DisposableStore();
      updateStyle();

      if (!isMultisashResize) {
        this.onDidEnablementChange(updateStyle, null, disposables);
      }

      var onMouseMove = function onMouseMove(e) {
        EventHelper.stop(e, false);
        var mouseMoveEvent = new StandardMouseEvent(e);
        var event = {
          startX: startX,
          currentX: mouseMoveEvent.posx,
          startY: startY,
          currentY: mouseMoveEvent.posy,
          altKey: altKey
        };

        _this2._onDidChange.fire(event);
      };

      var onMouseUp = function onMouseUp(e) {
        EventHelper.stop(e, false);

        _this2.el.removeChild(style);

        removeClass(_this2.el, 'active');

        _this2._onDidEnd.fire();

        disposables.dispose();

        var _iterator2 = _createForOfIteratorHelper(iframes),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var iframe = _step2.value;
            iframe.style.pointerEvents = 'auto';
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      };

      domEvent(window, 'mousemove')(onMouseMove, null, disposables);
      domEvent(window, 'mouseup')(onMouseUp, null, disposables);
    }
  }, {
    key: "onMouseDoubleClick",
    value: function onMouseDoubleClick(e) {
      var orthogonalSash = this.getOrthogonalSash(e);

      if (orthogonalSash) {
        orthogonalSash._onDidReset.fire();
      }

      if (this.linkedSash) {
        this.linkedSash._onDidReset.fire();
      }

      this._onDidReset.fire();
    }
  }, {
    key: "onTouchStart",
    value: function onTouchStart(event) {
      var _this3 = this;

      EventHelper.stop(event);
      var listeners = [];
      var startX = event.pageX;
      var startY = event.pageY;
      var altKey = event.altKey;

      this._onDidStart.fire({
        startX: startX,
        currentX: startX,
        startY: startY,
        currentY: startY,
        altKey: altKey
      });

      listeners.push(addDisposableListener(this.el, EventType.Change, function (event) {
        if (types.isNumber(event.pageX) && types.isNumber(event.pageY)) {
          _this3._onDidChange.fire({
            startX: startX,
            currentX: event.pageX,
            startY: startY,
            currentY: event.pageY,
            altKey: altKey
          });
        }
      }));
      listeners.push(addDisposableListener(this.el, EventType.End, function (event) {
        _this3._onDidEnd.fire();

        dispose(listeners);
      }));
    }
  }, {
    key: "layout",
    value: function layout() {
      if (this.orientation === 0
      /* VERTICAL */
      ) {
        var verticalProvider = this.layoutProvider;
        this.el.style.left = verticalProvider.getVerticalSashLeft(this) - this.size / 2 + 'px';

        if (verticalProvider.getVerticalSashTop) {
          this.el.style.top = verticalProvider.getVerticalSashTop(this) + 'px';
        }

        if (verticalProvider.getVerticalSashHeight) {
          this.el.style.height = verticalProvider.getVerticalSashHeight(this) + 'px';
        }
      } else {
        var horizontalProvider = this.layoutProvider;
        this.el.style.top = horizontalProvider.getHorizontalSashTop(this) - this.size / 2 + 'px';

        if (horizontalProvider.getHorizontalSashLeft) {
          this.el.style.left = horizontalProvider.getHorizontalSashLeft(this) + 'px';
        }

        if (horizontalProvider.getHorizontalSashWidth) {
          this.el.style.width = horizontalProvider.getHorizontalSashWidth(this) + 'px';
        }
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      this.hidden = true;
      this.el.style.display = 'none';
      this.el.setAttribute('aria-hidden', 'true');
    }
  }, {
    key: "onOrthogonalStartSashEnablementChange",
    value: function onOrthogonalStartSashEnablementChange(state) {
      toggleClass(this.el, 'orthogonal-start', state !== 0
      /* Disabled */
      );
    }
  }, {
    key: "onOrthogonalEndSashEnablementChange",
    value: function onOrthogonalEndSashEnablementChange(state) {
      toggleClass(this.el, 'orthogonal-end', state !== 0
      /* Disabled */
      );
    }
  }, {
    key: "getOrthogonalSash",
    value: function getOrthogonalSash(e) {
      if (this.orientation === 0
      /* VERTICAL */
      ) {
        if (e.offsetY <= this.size) {
          return this.orthogonalStartSash;
        } else if (e.offsetY >= this.el.clientHeight - this.size) {
          return this.orthogonalEndSash;
        }
      } else {
        if (e.offsetX <= this.size) {
          return this.orthogonalStartSash;
        } else if (e.offsetX >= this.el.clientWidth - this.size) {
          return this.orthogonalEndSash;
        }
      }

      return undefined;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(Sash.prototype), "dispose", this).call(this);

      this.el.remove();
    }
  }]);

  return Sash;
}(Disposable);